import React, { useCallback, useEffect, useState } from "react";
import { Duration } from "../utils/types";
import { getTeamAnswerDuration } from "../utils/firebase.actions";

export default function useDuration({ teamId }: { teamId: string }) {
  const [duration, setDuration] = useState<Duration>();
  const getGameTime = useCallback(async () => {
    const duration = await getTeamAnswerDuration(teamId);
    setDuration(duration);
  }, [duration]);

  useEffect(() => {
    getGameTime();
  }, []);

  return duration;
}
